<template>
  <div class="car-main-tabs car-tabs car-reduced-width" v-if="tabs[0] && !tabs[0].hide && showMainTabs()">
    <router-link
      class="car-tab"
      :to="{ path: tab.href }"
      :data-js="tab.dataJs"
      v-for="tab in tabs"
      :key="tab.name"
    >
      {{ $t(tab.label) }}
    </router-link>
  </div>
</template>

<script>
import utils from '@/util/utils';
import locationApiService from '@/modules/simpleService/services/locationApiService';

export default {
  name: 'MainTabs',
  data() {
    return {
      isContactRequestEnabled: false
    }
  },
  created() {
    this.checkIfContactRequestIsEnabled()
  },
  methods: {
    showMainTabs() {
      return !utils.isSingleService() && this.isContactRequestEnabled;
    },
    checkIfContactRequestIsEnabled() {
      let locationId;
      this.$store.dispatch('location/getLocation')
        .then(res => {
          locationId = res.data.locationId
          return locationApiService.getCapabilities([res.data.locationId]);
        })
        .then(res => {
          this.isContactRequestEnabled = res.data[locationId].supportsContactRequest;
        })
    }
  },
  computed: {
    tabs() {
      return this.$store.getters['tab/tabs'];
    }
  }
}
</script>
